(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ChangeFieldSearch', ChangeFieldSearch);

    ChangeFieldSearch.$inject = ['$resource'];

    function ChangeFieldSearch($resource) {
        var resourceUrl =  'api/_search/change-fields/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
